import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=0916fc98&scoped=true&"
var script = {}
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=0916fc98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916fc98",
  null
  
)

export default component.exports